import { ReactNode } from 'react'
import { cn } from '../lib/utils'
import './CirclesBackground.css'

interface Props {
  children: ReactNode
  className?: string
}

function CirclesBackground({ className, children }: Props) {
  return (
    <div
      className={cn('CirclesBackground relative overflow-hidden', className)}
    >
      {children}
    </div>
  )
}

export default CirclesBackground
